import React from 'react';
import { ethers } from 'ethers';
import { Button, Spinner } from 'react-bootstrap';

const BridgeSelectionBar = ({
  selectedCount,
  totalEstimatedFee,
  feeQuoting,
  feeError,
  nativeCurrencySymbol,
  destinationChain,
  onBridge,
  onCancel,
}) => {
  const feeDisplay = totalEstimatedFee
    ? `~${parseFloat(ethers.utils.formatEther(totalEstimatedFee)).toFixed(6)} ${nativeCurrencySymbol}`
    : feeError || '...';

  return (
    <div className="bridge-selection-bar">
      <div className="bridge-bar-info">
        <span className="bridge-bar-count">{selectedCount} NFT{selectedCount !== 1 ? 's' : ''} selected</span>
        <span className="bridge-bar-divider">|</span>
        <span className="bridge-bar-fee">
          Est. fee: {feeQuoting ? <Spinner animation="border" size="sm" /> : feeDisplay}
        </span>
      </div>
      <div className="bridge-bar-actions">
        <Button
          variant="success"
          className="bridge-bar-btn"
          onClick={onBridge}
          disabled={feeQuoting || !!feeError}
        >
          Bridge to {destinationChain} &#10145;
        </Button>
        <Button variant="outline-secondary" className="bridge-bar-cancel" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default BridgeSelectionBar;
